import axios from 'axios';
import { toast } from 'sonner';

/** Sunucu taraflı PDF/Excel çıktısını indirir (ekrandaki filtrelerle aynı parametreler). */
export const downloadFile = async (url, params, filename) => {
  try {
    const res = await axios.get(url, { params, responseType: 'blob' });
    const href = window.URL.createObjectURL(new Blob([res.data]));
    const a = document.createElement('a');
    a.href = href;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(href);
    toast.success('Rapor indirildi');
    return true;
  } catch (e) {
    toast.error('Rapor oluşturulamadı');
    return false;
  }
};

export default downloadFile;
